module.exports = __webpack_public_path__ + "static/media/ca-next-arrow-icon.770bcd95.svg";